import MUIIconButton from '@mui/material/IconButton';
import { type Theme, useTheme } from '@mui/material/styles';
import type { FunctionComponent } from 'react';
import styled from 'styled-components';

import type { IconButtonProps } from './IconButton.model';
import { generateButtonCss } from './IconButton.styles';

const StyledIconButton = styled(MUIIconButton).withConfig({
  shouldForwardProp: (prop) => !['icon', 'theme'].includes(prop),
})<IconButtonProps>`
  ${({ theme, ...props }) => generateButtonCss(theme, props)}
`;

/* BD Design System Button Component */
const IconButton: FunctionComponent<IconButtonProps> = ({
  size = 'medium',
  variant = 'outline',
  ...props
}) => {
  const theme = useTheme<Theme>();

  /* Remove variant from props as MUI doesn't know what our variants are. */
  const convertedProps = { ...props, variant: undefined };

  /* Helper function to clean up style class name generation */
  const generateIconButtonClassName = (): string => {
    const sizeClass = size;
    const variantClass = variant;

    return `${props.className} ${variantClass} ${sizeClass}`;
  };

  return (
    <StyledIconButton
      {...convertedProps}
      className={generateIconButtonClassName()}
      theme={theme}
    >
      {props.icon}
    </StyledIconButton>
  );
};

export default IconButton;
